module.exports = __webpack_public_path__ + "static/media/COBRANDING_ELECCIONES_2023-02.9ad3323f.png";